<template>
  <div class="container">
    <div v-if="state.isBusy" class="info">
      <h1>Envio automático</h1>
      <h3>{{state.curr}} de {{state.total}}</h3>
      <h5>{{state.email}}</h5>
    </div>
    <div class="text-left">
      <h3>
        <router-link to="/Emails">Email</router-link>
        <div class="pull-right">
          <button @click.prevent="sendAuto(10)" class="btn btn-primary">Enviar 10</button>
          <button @click.prevent="sendAuto(25)" class="btn btn-primary">Enviar 25</button>
          <button @click.prevent="sendAuto(50)" class="btn btn-primary">Enviar 50</button>
        </div>
      </h3>
      <h4>Assunto:{{mail.assunto}}</h4>
      <small>Atualmente enviados <b>{{clientes.length-maillist.clientes.length}}</b> de <b>{{clientes.length}}</b> destinatários deste email.</small>
      <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
    </div>
    <table v-show="!state.isBusy">
      <tr>
        <td></td>
        <td>cnpj</td>
        <td>razao</td>
        <td>cidade</td>
        <td>email</td>
      </tr>
      <tr v-for="cliente in clientes" :class="cliente.status? 'bg-success text-success' : ''">
        <td><a v-if="!cliente.status" @click.prevent="sendMail(cliente.email)" class="glyphicon glyphicon-envelope" :title="'Enviar para '+cliente.email"></a></td>
        <td>{{maskCnpj(cliente.cnpj)}}</td>
        <td>
          {{cliente.razao}}<br>
          <small>{{cliente.fantasia}}</small>
        </td>
        <td>{{cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade}}</td>
        <td>{{cliente.email}}</td>
      </tr>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    data () {
      return {
        state: {
          isBusy: false,
          curr: 0,
          total: 0,
          email: ''
        },
        clientes: [],
        mail: {
          cod: 0,
          assunto: 'Teste do email',
          conteudo: '<b>Corpo</b> do email'
        },
        maillist: {
          clientes: []
        }
      }
    },
    methods: {
      send (params = '') {
        console.log('Try Send...')
        const url = './api/php/sendmail.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              console.log('Try Confirm...' + this.mail.cod + ' ' + params.destinatario)
              this.confirmSend({'cod': this.mail.cod, 'email': params.destinatario})
            } else {
              console.log('Ocorreu um erro ao enviar o email')
              console.log(response.body.error)
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      sendMail (email) {
        this.send({'assunto': this.mail.assunto, 'conteudo': this.mail.conteudo, 'destinatario': email})
      },
      sendAuto (qtd) {
        this.state.isBusy = true
        this.state.curr = 0
        this.state.total = qtd
        this.filterPendentes()
      },
      confirmSend (params = '') {
        console.log('Try confirm...')
        const url = './api/php/confirmsend.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.updateMailList(response.body.email)
            } else {
              console.log(response.body)
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      updateMailList (email) {
        const l = this.clientes.length
        for (let i = 0; i < l; i++) {
          if (this.clientes[i].email === email) {
            this.clientes[i].status = true
          }
        }
        this.filterPendentes()
      },
      loadEmail (params = '') {
        const url = './api/php/getemail.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body.assunto)
            if (response.body.cod !== undefined) {
              this.mail = response.body
              this.loadEmailList({'cod': this.mail.cod})
            } else {
              console.log('Não foi possível carregar o email')
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      loadEmailList (params = '') {
        const url = './api/php/getemaillist.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.clientes = response.body.rows
              this.filterPendentes()
              console.log(this.maillist.clientes.length)
            } else {
              console.log(response.body.error)
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      filterPendentes () {
        this.maillist.clientes = this.clientes.filter(cliente => !cliente.status)
        if (this.state.isBusy === true && this.state.curr < this.state.total) {
          this.state.curr++
          this.state.email = this.maillist.clientes[0].email
          this.sendMail(this.state.email)
        } else {
          this.state.isBusy = false
          this.state.curr = 0
          this.state.total = 0
          this.state.email = ''
        }
      },
      select4edit (cod) {
        this.$router.push({path: `/cliente/${cod}`})
      }
    },
    created: function () {
      this.maskCnpj = Mask.cnpj
      this.maskMonetario = Mask.monetario
      this.maskTelefone = Mask.telefone
      // const keyword = this.$route.query.s
      const cod = this.$route.params.id
      this.loadEmail({'cod': cod})
    },
    watch: {
      '$route' (to, from) {
        // const keyword = this.$route.query.s
        const cod = this.$route.params.id
        this.loadEmail({'cod': cod})
      }
    }
  }
</script>

<style scoped>
  container {
    width: 80vw;
    margin: auto;
  }
  .info {
    position: fixed;
    width: 40vw;
    height: 30vh;
    margin: 25vh 20vw 20vh 20vw;
    background: #fff;
    box-shadow: 5px 5px 10px #ccc;
    text-align: center;
    border: 1px solid #dedede;
  }
  table {
    font: 12px sans-serif;
    color: #333;
    border-collapse: collapse;
    outline: 2px solid #333;
    text-align: left;
    width: 100%;
  }
  table tr:not(.bg-success) {
    background: #fcfcfc;
  }
  table tr:nth-child(2n+1):not(.bg-success):not(':first-clild') {
    background: #f1f1f1;
  }
  table tr:first-child {
    background: #333;
    color: #fff;
    text-transform: uppercase;
  }
  table tr:hover{
    background: #ccc;
  }
  table tr td {
    padding: 5px;
  }
  table tr td small {
    color: #777;
  }
  a.glyphicon {
    text-decoration: none;
  }
  .searchbox {
    margin: 10px 50px 10px 0;
  }
  div.use {
    display: inline;
  }
  .nowrap {
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmailRelSend.vue